import React from "react";
import DateInput from "../inputs/DateInput";

class JalaliDateFilterInput extends React.Component {
    state = {
        checked: true,
        operator: '=',
        startDate: null,
        endDate: null
    }

    componentWillMount() {
        // Initialize with existing data if available
        if (this.props.data) {
            this.setState({
                startDate: this.props.data.startDate,
                endDate: this.props.data.endDate
            });
        }
    }

    checkSettings(param) {
        if (this.props.settings) {
            return this.props.settings[param]
        } else {
            return false
        }
    }

    changeDate = (key, value, extra) => {
        this.setState({ [key]: value }, () => {
            // After state is updated, send the filter data to parent
            this.updateParentFilter();
        });
    }

    updateParentFilter = () => {
        const { startDate, endDate } = this.state;
        
        // Only send filter if at least one date is selected
        if (startDate || endDate) {
            // Create array with [startDate, endDate] format for backend
            const filterValue = [startDate, endDate];

            this.props.changeValue(this.props.header.key, filterValue, {
                type: this.props.header.type,
                operator: 'between',
                label: this.props.header.information?.label,
                dictionary: this.props.header.information?.dictionary
            });
        } else {
            // Clear filter if no dates selected
            this.props.changeValue(this.props.header.key, null, {});
        }
    }

    clearFilter = () => {
        this.setState({ startDate: null, endDate: null }, () => {
            this.props.changeValue(this.props.header.key, null, {});
        });
    }

    render() {
        let info = this.props.header?.information;
        
        return (
            <div className='mt-1'>
                {/* Single Row with two date inputs side by side */}
                <div className="" style={{ display: 'flex', width: '100%', gap: '10px' }}>
                    <div style={{ flex: 1, minWidth: '150px' }}>
                        <p className="text-smaller mb-1 px-1">از تاریخ</p>
                        <div style={{ padding: '2px 10px', borderRadius: 8, backgroundColor: '#f6f6f6' }}>
                            <DateInput 
                                startOrEnd={'start'} 
                                header={{ 
                                    key: 'startDate', 
                                    information: { placeholder: 'از ...' } 
                                }} 
                                changeValue={this.changeDate} 
                                data={this.state.startDate} 
                            />
                        </div>
                    </div>

                    <div style={{ flex: 1, minWidth: '150px' }}>
                        <p className="text-smaller mb-1 px-1">تا تاریخ</p>
                        <div style={{ padding: '2px 10px', borderRadius: 8, backgroundColor: '#f6f6f6' }}>
                            <DateInput 
                                startOrEnd={'end'} 
                                startDate={this.state.startDate ? this.state.startDate : (new Date).getTime()} 
                                header={{ 
                                    key: "endDate", 
                                    information: { placeholder: 'تا ...' } 
                                }} 
                                changeValue={this.changeDate} 
                                data={this.state.endDate} 
                            />
                        </div>
                    </div>

                    {/* Clear Filter Button */}
                    <div style={{ display: 'flex', alignItems: 'end', paddingBottom: '2px' }}>
                        <button 
                            onClick={this.clearFilter}
                            className="btn btn-sm btn-outline-secondary"
                            style={{ fontSize: '12px', height: 'fit-content' }}
                            title="پاک کردن فیلتر"
                        >
                            ✕
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default JalaliDateFilterInput;